import Image from "next/image";
import type { StaticImageData } from "next/image";
import { clsx } from "clsx";

import { Noise } from "@ui/components/core/Noise/Noise";

interface CalculatorResultCardShellProps {
  coverImage?: StaticImageData;
  bg: "black" | "cream";
  children: React.ReactNode;
}

const BG_CLASS = {
  black: "tw-bg-black",
  cream: "tw-bg-cream",
} as const;

export function CalculatorResultCardShell({ coverImage, bg, children }: CalculatorResultCardShellProps) {
  return (
    <div className='tw-relative tw-w-full lg:tw-aspect-square'>
      <div className='tw-relative tw-inset-0 tw-overflow-hidden tw-rounded-2xl lg:tw-absolute'>
        <div className={clsx("tw-absolute tw-inset-0 tw-w-full tw-h-full", BG_CLASS[bg])} />
        {coverImage && (
          <div className='tw-absolute tw-inset-0 tw-w-full tw-h-full'>
            <Image src={coverImage} alt='' fill className='tw-object-cover' quality={90} placeholder='blur' />
          </div>
        )}
        <Noise className='tw-rounded-2xl' />
        <div className='tw-relative tw-z-10 tw-flex tw-h-full tw-flex-col tw-p-5 lg:tw-p-10'>{children}</div>
      </div>
    </div>
  );
}
